import { Button } from '@clariness/button';
import { FormattedMessage } from 'react-intl';
import { Environment } from 'global/environment';
import { Services } from 'services';
import { Store } from 'store';
import { getManualReferralEligibleAssignments } from 'services/referrals/create-manual-referral/eligibility';

export const ReferralTableAddPatient = () => {
  const { openModal } = Store.useModal();
  const { user } = Store.useUser();
  const { data: investigatorStudies } =
    Services.SiteEmployees.useGetInvestigatorStudies();

  const manualReferralEligibleAssignments =
    getManualReferralEligibleAssignments(
      investigatorStudies?.investigatorNotificationUpdateDto,
      user
    );
  const canAddExternalReferral =
    Environment.FEATURE_MANUAL_REFERRAL_ENABLED === 'true' &&
    manualReferralEligibleAssignments.length > 0;

  if (!canAddExternalReferral) {
    return null;
  }

  return (
    <Button
      onClick={() =>
        openModal({
          modalType: 'AddExternalReferral',
        })
      }
      data-test-id="open-add-external-referral-modal-button"
    >
      <FormattedMessage
        id="is.home_page.add_external_referral_button"
        defaultMessage="Add Patient+"
      />
    </Button>
  );
};
